<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        fill-opacity="0"
        aria-hidden="true"
        class="leo-sparkle-icon">
        <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="11.5"
            vector-effect="non-scaling-stroke"
            class="leo-sparkle-icon__circle" />
        <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="11.5"
            vector-effect="non-scaling-stroke"
            :stroke="`url(#apsi-border-${$.uid})`" />
        <path
            class="leo-sparkle-icon__star"
            :class="{ 'leo-sparkle-icon__star--spinning': spinning }"
            d="M12.1227 18.9766C12.0918 19.1069 11.9063 19.1066 11.8758 18.9762L11.3105 16.564C11.0888 15.6218 10.6087 14.7601 9.92432 14.0757C9.2399 13.3912 8.37821 12.9112 7.43602 12.6895L5.02605 12.1248C4.89553 12.0942 4.89544 11.9084 5.02593 11.8777L7.43603 11.3105C8.37821 11.0888 9.2399 10.6088 9.92432 9.92433C10.6087 9.23991 11.0888 8.37821 11.3105 7.43603L11.8752 5.02605C11.9058 4.89553 12.0916 4.89544 12.1223 5.02593L12.6895 7.43603C12.9087 8.38099 13.3877 9.24588 14.0723 9.93314C14.7569 10.6204 15.6199 11.1027 16.564 11.3256L18.9741 11.8928C19.1046 11.9235 19.1045 12.1093 18.974 12.1399L16.564 12.7046C15.6248 12.9261 14.7657 13.4043 14.0826 14.0858C13.3995 14.7673 12.9192 15.6253 12.6955 16.564L12.1227 18.9766Z"
            vector-effect="non-scaling-stroke"
            fill-opacity="1"
            :stroke="`url(#apsi-sparkle-${$.uid})`" />
        <defs>
            <linearGradient
                :id="`apsi-border-${$.uid}`"
                x1="12"
                y1="0"
                x2="31.125"
                y2="27.375"
                gradientUnits="userSpaceOnUse">
                <stop class="leo-sparkle-icon__gradient-purple" />
                <stop
                    offset="1"
                    class="leo-sparkle-icon__gradient-teal-light" />
            </linearGradient>
            <linearGradient
                :id="`apsi-sparkle-${$.uid}`"
                x1="8.3384"
                y1="8.201"
                x2="16.0679"
                y2="17.3626"
                gradientUnits="userSpaceOnUse">
                <stop class="leo-sparkle-icon__gradient-purple" />
                <stop
                    offset="1"
                    class="leo-sparkle-icon__gradient-teal" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'LeoSparkleIcon',
    props: {
        size: {
            type: Number,
            default: 24,
        },
        spinning: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="less">
.leo-sparkle-icon {
    vertical-align: middle;
    flex-shrink: 0;

    &__circle {
        fill: var(--palette-gray-0);
    }

    &__star {
        fill: var(--palette-teal-30);
        transform-box: fill-box;
        transform-origin: center;

        &--spinning {
            animation: sparkle-spin 0.5s ease-in-out;
        }
    }

    &__gradient-purple {
        stop-color: var(--palette-purple-50);
    }

    &__gradient-teal-light {
        stop-color: var(--palette-teal-30);
    }

    &__gradient-teal {
        stop-color: var(--palette-teal-40);
    }
}

@keyframes sparkle-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}
</style>
